// extracted by mini-css-extract-plugin
export var headerSection = "HealthRecovery-module--headerSection--oev5b";
export var healthRecoveryWrapper = "HealthRecovery-module--healthRecoveryWrapper--9j-ga";
export var mainTitle = "HealthRecovery-module--mainTitle--MxEA5";
export var stageCard = "HealthRecovery-module--stageCard--CYE44";
export var stageContent = "HealthRecovery-module--stageContent--mT5eP";
export var stageDescription = "HealthRecovery-module--stageDescription--22KCI";
export var stageHeader = "HealthRecovery-module--stageHeader--y+i2A";
export var stageLabel = "HealthRecovery-module--stageLabel--ZaesF";
export var stageTime = "HealthRecovery-module--stageTime--o39tf";
export var stageTitle = "HealthRecovery-module--stageTitle--V3j0m";
export var stagesGrid = "HealthRecovery-module--stagesGrid--eXAUK";